import { RankingController } from "./Ranking";
import { LeagueService, TeamService, UserService, Ladder, IRankingEntry, LeagueFactory } from "ng-league";
import { OnlineStatusResource } from "../services/api/drupal/OnlineStatusResource";
import { Store } from "@ngrx/store";
import { EntryState, RootState, getLeague, LoadLeagueOnceAction, getUser, distinct, getContestants, entryAvailable } from "@play/state";
import { League } from "@play/api-typings";
import { IRankingScope } from "./RankingScope";
import { filter, map } from "rxjs/operators";

export class LadderRankingController extends RankingController {
    public isLoggedIn: boolean = false;
    public isInLadder: boolean = false;
    public onlineUsers: string[] = [];
    public league: Ladder;
    public round: number; // Current round number

    public static $inject = ["$scope", "SettingsService", "LeagueService", "TeamService", "UserService", "OnlineStatusResource", "store"];
    constructor(
        protected $scope: IRankingScope,
        protected SettingsService,
        protected LeagueService: LeagueService,
        protected TeamService: TeamService,
        protected UserService: UserService,
        protected OnlineStatusResource: OnlineStatusResource,
        protected store: Store<RootState>
    ) {
        super($scope, SettingsService, LeagueService, TeamService, UserService, store);

        const userId = this.SettingsService.user ? +this.SettingsService.user.id : null;

        this.store.dispatch(new LoadLeagueOnceAction(this.leagueId));
        this.store
            .select(getLeague(this.leagueId))
            .pipe(filter(Boolean))
            .subscribe((league: EntryState<League>) => {
                if (!league.entry) {
                    return;
                }

                this.league = LeagueFactory.getLeagueByType(league.entry) as any;
                this.loading = league.loading;
            });
        this.store
            .select(getUser)
            .pipe(
                filter(user => user && Boolean(!user.loading || user.entry)),
                distinct(user => Boolean(user.entry))
            )
            .subscribe(data => {
                this.isLoggedIn = data;
            });
        this.store
            .select(getContestants(this.leagueId, userId))
            .pipe(
                filter(entryAvailable),
                map(contestants => contestants.entry)
            )
            .subscribe(data => {
                this.isInLadder = data && data.length > 0;
            });
    }

    public isOnline(ranking: IRankingEntry) {
        return this.onlineUsers.indexOf(ranking.getContestant().getId()) != -1;
    }

    public getContestantRepUrl(rank: IRankingEntry) {
        let contestantType = "player";
        let contestant: any = null;

        if (rank.isTeam()) {
            contestant = rank.getTeam();
        } else {
            contestant = rank.getUser();
        }

        let id = contestant.getId();
        if (typeof contestant.getAlias === "function") {
            id = contestant.getAlias();
        }

        if (rank.isTeam()) {
            contestantType = "team";
        }

        return "/" + contestantType + "/credibility/" + id;
    }

    protected loadOnlineStatus(rankings: IRankingEntry[]) {
        if (rankings.length > 0 && !rankings[0].isTeam()) {
            let ids = rankings.map((ranking: IRankingEntry) => {
                return ranking.getContestant().getId();
            });

            this.OnlineStatusResource.getOnlineStatus(ids).then(data => {
                this.onlineUsers = data;
            });
        }
    }

    protected loadData(ranking: IRankingEntry[]) {
        this.setTeamMembers(ranking);
        this.setUsersShortDescriptions(ranking);
        this.loadOnlineStatus(ranking);
    }
}
